module.exports = __webpack_public_path__ + "static/media/CardboardBox.f3b47511.glb";